import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [showAutoBubble, setShowAutoBubble] = useState(false);
  const [bubbleDismissed, setBubbleDismissed] = useState(false);
  const whatsappNumber = '33622360190'; // Format international français
  
  // Afficher la bulle automatique après 5 secondes (une seule fois par session)
  useEffect(() => {
    const hasSeenBubble = sessionStorage.getItem('whatsapp_bubble_seen');
    
    if (!hasSeenBubble) {
      const showTimer = setTimeout(() => {
        setShowAutoBubble(true);
      }, 5000); // Apparaît après 5 secondes
      
      return () => clearTimeout(showTimer);
    }
  }, []);

  // Faire disparaître la bulle après 10 secondes
  useEffect(() => {
    if (showAutoBubble && !bubbleDismissed) {
      const hideTimer = setTimeout(() => {
        setShowAutoBubble(false);
        sessionStorage.setItem('whatsapp_bubble_seen', 'true');
      }, 10000); // Disparaît après 10 secondes
      
      return () => clearTimeout(hideTimer);
    }
  }, [showAutoBubble, bubbleDismissed]);

  const dismissBubble = () => {
    setShowAutoBubble(false);
    setBubbleDismissed(true);
    sessionStorage.setItem('whatsapp_bubble_seen', 'true');
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent(
      "Bonjour AutoSpa 77, je souhaite avoir des informations sur vos services de detailing automobile."
    );
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappURL, '_blank');
    dismissBubble();
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Bulle automatique - Option A */}
      {showAutoBubble && !showTooltip && (
        <div 
          className="absolute bottom-16 right-0 mb-2 animate-fade-in-up"
          style={{
            animation: 'fadeInUp 0.4s ease-out'
          }}
        >
          <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 p-4 w-72">
            {/* Petite flèche vers le bouton */}
            <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-gray-100 transform rotate-45"></div>
            
            {/* Bouton fermer */}
            <button
              onClick={dismissBubble}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
            
            {/* Contenu */}
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-green-600" />
              </div>
              <div className="flex-1 pr-4">
                <p className="text-gray-800 font-medium text-sm leading-snug">
                  💬 Une question ? Écrivez-nous sur WhatsApp !
                </p>
                <p className="text-gray-500 text-xs mt-1">
                  Réponse rapide garantie
                </p>
              </div>
            </div>
            
            {/* Bouton CTA */}
            <button
              onClick={openWhatsApp}
              className="w-full mt-3 bg-green-500 hover:bg-green-600 text-white px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 shadow-sm hover:shadow-md"
            >
              <MessageCircle className="w-4 h-4" />
              Discuter maintenant
            </button>
          </div>
        </div>
      )}

      {/* Tooltip au clic (existant) */}
      {showTooltip && (
        <div className="absolute bottom-16 right-0 bg-white p-3 rounded-lg shadow-lg border mb-2 w-64">
          <div className="flex justify-between items-start mb-2">
            <h4 className="font-semibold text-gray-900 text-sm">
              Besoin d'aide ?
            </h4>
            <button
              onClick={() => setShowTooltip(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="text-gray-600 text-xs mb-3">
            Contactez-nous directement via WhatsApp pour un devis rapide ou toute question sur nos services.
          </p>
          <button
            onClick={openWhatsApp}
            className="w-full bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex items-center justify-center space-x-2"
          >
            <MessageCircle className="w-4 h-4" />
            <span>Démarrer la conversation</span>
          </button>
        </div>
      )}

      {/* Bouton WhatsApp principal */}
      <button
        onClick={() => {
          dismissBubble();
          setShowTooltip(!showTooltip);
        }}
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 group"
        title="Contactez-nous sur WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
      </button>

      {/* Animation de notification */}
      {!bubbleDismissed && (
        <div className="absolute top-0 right-0 w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
      )}
      
      {/* CSS pour l'animation */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;